export default {
    open: "Odpowiedz teraz",
    approve: "Zatwierdź teraz",
    impersonation: {
        title: "Zamawiasz w imieniu «{name}»",
        cta: "Przełącz się z powrotem na mnie",
    },
    "You have an unapproved orders": "Masz zamówienia do zatwierdzenia",
    "You have orders to approve": "Masz zamówienia do zatwierdzenia"
}